import {
    PedalBike as IconBike,
    DirectionsCar as IconCar,
    Hail as IconCarpool,
    CarRental as IconMyWheels,
} from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";

import { GqlPlannerV2SummaryTravelMethod } from "~/__generated__";

type NextShiftTravelInfoProps = {
    travelType: GqlPlannerV2SummaryTravelMethod;
};

export default function NextShiftTravelInfo({ travelType }: NextShiftTravelInfoProps) {
    return (
        <Stack direction="row" alignItems="center" rowGap={1} justifyContent="flex-start">
            <Stack direction="row" columnGap={1}>
                {TRAVEL_TYPE_ICON_CONFIG[travelType]}
                <Typography textTransform="capitalize">{travelType}</Typography>
            </Stack>
            {travelType === GqlPlannerV2SummaryTravelMethod.MyWheels && (
                <Stack direction="row">
                    <IconCarpool />
                    <Typography>Carpool</Typography>
                </Stack>
            )}
        </Stack>
    );
}

const TRAVEL_TYPE_ICON_CONFIG: Partial<Record<GqlPlannerV2SummaryTravelMethod, React.ReactElement>> = {
    [GqlPlannerV2SummaryTravelMethod.Bike]: <IconBike />,
    [GqlPlannerV2SummaryTravelMethod.MyWheels]: <IconMyWheels />,
    [GqlPlannerV2SummaryTravelMethod.PrivateCar]: <IconCar />,
};
